{
  "contact-update-dialog": {
    "buttons": {
      "confirm": "Potvrďte",
      "skip": "Přeskočit"
    },
    "text": {
      "confirm-email": "Potvrzení e-mailem",
      "confirm-email-hint": "Potvrďte prosím svůj e-mail",
      "confirm-phone-number": "Potvrzení telefonního čísla",
      "confirm-phone-number-hint": "Potvrďte prosím své telefonní číslo",
      "enter-email": "Chybí e-mail",
      "enter-email-hint": "Nastavte prosím svůj e-mail",
      "enter-phone-number": "Chybí telefonní číslo",
      "enter-phone-number-hint": "Nastavte prosím své telefonní číslo",
      "in-second": "v {{seconds}} s"
    }
  }
}
